import { rowStructure } from '../../redux/features/burst/types';

const createEmptyRow = (row: rowStructure): rowStructure => {
  return {
    ...row,
    budget: 0,
    tarps: 0,
    impact: 0
  };
};

export default createEmptyRow;
